import { render, staticRenderFns } from "./indexImpr.vue?vue&type=template&id=627fafc6"
import script from "./indexImpr.vue?vue&type=script&lang=js"
export * from "./indexImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627fafc6')) {
      api.createRecord('627fafc6', component.options)
    } else {
      api.reload('627fafc6', component.options)
    }
    module.hot.accept("./indexImpr.vue?vue&type=template&id=627fafc6", function () {
      api.rerender('627fafc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main/indexImpr.vue"
export default component.exports